import { withStylePrefix } from '../common/withStylePrefix';
import { CodeComponent, codeTemplate } from './Code';
import styles from './Code.styles.scss';
export const codeDefinition = {
    baseName: 'code',
    template: codeTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonCode = CodeComponent.compose(codeDefinition);
